import React, { useState } from 'react';
import Toggle from '../../../Toggle';
import * as Ui from './styles';

/**
 * Componente de item de menu, que manipula o tipo
 * de exibicao de dados de um card
 */
function ToogleMenu({
  /**
   * Define como marcado ou desmarcado
   */
  initialChecked = false,
  /**
   * propaga o evento de ligado e desligado do botão
   */
  onChange,
  /**
   * para outras propriedades
   */
  ...props
}) {
  // props from styled-components
  const { className } = props;

  // state
  const [checked, setChecked] = useState(initialChecked);

  function handleCheckedChange() {
    const oldChecked = checked;
    setChecked(!oldChecked);
    if (onChange) onChange(!oldChecked);
  }

  return (
    <Ui.Container className={className}>
      <Ui.Action>
        <Toggle
          checked={checked}
          onChange={handleCheckedChange}
        />
      </Ui.Action>
      <Ui.Label>
        <span>Ativar predição</span>
      </Ui.Label>
    </Ui.Container>
  );
}

export default ToogleMenu;
